(function() { module.exports = window["eventespresso"]["dates"]; }());